import { Typography } from "@mui/material";
import { PropsWithChildren } from "react";

const GreenH2 = ({ children }: PropsWithChildren) => {
    return (
        <Typography component={"span"} variant={"h2"} color="green">
            {children}
        </Typography>
    );
};

export default GreenH2;
